// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"968e7839","453":"63f02708","732":"f4df0d8f","977":"5ef1d616"}[chunkId] + ".chunk.js";
};